import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styles from "./IntroduccioIndividu.module.css";
import IntroduccioTitolClasse from "./IntroduccioTitolClasse";
import IntroduccioIndividuFenofases from "./IntroduccioIndividuFenofases";
import { getTitolsClasses } from "../../reducers";

const getEspecie = (especies, idIndividu) => {
  if (!especies) {
    return null;
  }

  const especie = Object.keys(especies).find(especie => {
    return especies[especie].idIndividu === idIndividu;
  });

  if (!especie) {
    return null;
  }

  return { especie: especies[especie], IdEspecie: Number(especie) };
};

const getNumObservacionsPerEspecie = (valors, fenofases, IdEspecie) => {
  const listaFenofasesPerEspecie = getFenofasesPerEspecie(fenofases, IdEspecie);
  const llistaValors = Object.keys(valors).filter(valor => {
    return listaFenofasesPerEspecie.indexOf(valors[valor].idFenofase) > -1;
  });

  return llistaValors.length;
};

const getFenofasesPerEspecie = (fenofases, IdEspecie) => {
  if (!fenofases) {
    return [];
  }

  let result = [];
  Object.keys(fenofases).forEach(fenofase => {
    if (fenofases[fenofase].idEspecie === IdEspecie) {
      result.push(parseInt(fenofase));
    }
  });
  return result;
};

const getTotalFenofasesPerEspecie = (fenofases, IdEspecie) => {
  if (!fenofases) {
    return 0;
  }

  let numFenofasesEspecie = 0;
  Object.keys(fenofases)
    .filter(fenofase => {
      return fenofases[fenofase].idEspecie === IdEspecie;
    })
    .forEach(fenof => {
      numFenofasesEspecie += fenofases[fenof].idIndividu.length;
    });
  return numFenofasesEspecie;
};

class IntroduccioIndividu extends React.Component {
  render() {
    const { classes, especies, fenofases, valors, history } = this.props;
    const classesNormalitzades = classes || {};
    const valorsNormalitzats = valors || {};
    let i = 0;
    return (
      <div className={styles.introduccioIndividu}>
        {Object.keys(classesNormalitzades).map(classe => (
          <div key={classe.toString()} className={styles.individu}>
            <IntroduccioTitolClasse
              key={classe.toString()}
              titolClasse={classesNormalitzades[classe].nomClasse}
            />
            <ul className={styles.llista}>
              {classesNormalitzades[classe].individus
                .slice()
                .sort((a, b) => {
                  return a - b;
                })
                .map(idIndividu => {
                  //Només es mostra 1 individu per espècie. Al carrusel sí que es mostren tots.
                  const especieMostrar = getEspecie(especies, idIndividu);
                  return especieMostrar && especieMostrar.IdEspecie ? (
                    <IntroduccioIndividuFenofases
                      history={history}
                      key={i++}
                      especie={especieMostrar.especie}
                      numObservacions={getNumObservacionsPerEspecie(
                        valorsNormalitzats,
                        fenofases,
                        especieMostrar.IdEspecie
                      )}
                      numFenofases={getTotalFenofasesPerEspecie(
                        fenofases,
                        especieMostrar.IdEspecie
                      )}
                    />
                  ) : null;
                })}
            </ul>
          </div>
        ))}
      </div>
    );
  }
}

IntroduccioIndividu.propTypes = {
  classes: PropTypes.object,
  especies: PropTypes.object,
  fenofases: PropTypes.object,
  valors: PropTypes.object,
  history: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    classes: getTitolsClasses(state),
    especies: state.especies,
    fenofases: state.fenofases,
    valors: state.introduccio ? state.introduccio.valors : undefined
  };
};

export default connect(mapStateToProps)(IntroduccioIndividu);
